
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Elements } from "../../../../shared/Elements";
import { ConfirmDialog, Siren } from "../../../../shared/ConfirmDialog";
import { BoolHelper, Button, ButtonManageRef, Checkbox, Classname, Form, FormControl, Scheme, TextAreaInput, TextInput } from "@rivtn/noseur";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { ApiResponseData, BaseService, IHost, IMember, IProfileWebsite, IHostManager, MemberService, SanitizedResponse, TeamRole, TeamService, HostService, ConsusService, IUploadedFile } from "../../../../../services";
import MediaInput from "../../../../shared/MediaInput";

export interface PeopleProps {
    host: IHost;
    profile: IMember;
}

function People(props: PeopleProps) {

    const hostService = HostService.getInstance();
    const consusService = ConsusService.getInstance();
    const labels = i18nManager.Labels.host.settings.about.people;
    const [selectedHostManager, setSelectedHostManager] = React.useState<IHostManager>();
    const [hostManagers, setHostManagers] = React.useState<ApiResponseData<IHostManager>>({});
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);

    React.useEffect(() => {
        fetchInformation();

        return () => {
            Utils.updateSearchParams("shmid", null, setSearchParams);
        };
    }, []);

    if (!selectedHostManager) return renderListing();

    return (<div className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none" }}>
        {!hostManagers.content ? (Elements.LOADING_STATE) : (<div className="tmems-details">
            <div>
                <div className="tmems-list">
                    {hostManagers.content.map((hostManager) => {
                        return (<div key={hostManager.external_id} className={Classname.build("tmems-l", { "active": hostManager.external_id === selectedHostManager?.external_id })} onClick={() => {
                            Utils.updateSearchParams("shmid", hostManager.external_id, setSearchParams, () => {
                                setSelectedHostManager(undefined);
                                setTimeout(() => setSelectedHostManager({ ...hostManager }), 100);
                            });
                        }}>
                            <img alt={hostManager.member?.username} src={hostManager.passport_picture_url} />
                        </div>);
                    })}
                </div>
                <span className="link" onClick={() => {
                    Utils.updateSearchParams("shmid", null, setSearchParams, () => setSelectedHostManager(undefined));
                }}>{i18nManager.Labels.common.close}</span>
            </div>
            <div className="tmem-detail">
                <div>
                    <div>
                        <MediaInput style={{ marginBottom: 0, flex: 1 }} width={"100%"} height={300} maxWidth={420}
                            noFillTemplate default={selectedHostManager.half_body_picture_url} onSelectFiles={(files) => {
                                consusService.uploadFile("/omnehost/host/manager/", `half_body_${selectedHostManager?.external_id}`, files[0]).then(({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                                    setSelectedHostManager({ ...selectedHostManager, half_body_picture_url: sanitized.consus_download_url });
                                    updateHostManager({ ...selectedHostManager, half_body_picture_url: sanitized.consus_download_url });
                                }).catch(BaseService.reportError);
                            }} onGenerateWithAi={async () => {
                                return new File(["We are here"], "we.txt", { type: 'text/plain' });
                            }} />
                        <FormControl isFieldset fill label={labels.role} style={{ marginTop: 15 }} rightContent={<i className="fa fa-star" />}>
                            <TextInput defaultValue={selectedHostManager.display_role} fill onInputComplete={(value: string) => {
                                setSelectedHostManager({ ...selectedHostManager, display_role: value });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.manager.twitch} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedHostManager.social_accounts["twitch"]} fill onInputComplete={(twitch: string) => {
                                setSelectedHostManager({ ...selectedHostManager, social_accounts: { ...selectedHostManager.social_accounts, twitch } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.manager.instagram} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedHostManager.social_accounts["instagram"]} fill onInputComplete={(instagram: string) => {
                                setSelectedHostManager({ ...selectedHostManager, social_accounts: { ...selectedHostManager.social_accounts, instagram } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.manager.twitter_x} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedHostManager.social_accounts["twitter_x"]} fill onInputComplete={(twitter_x: string) => {
                                setSelectedHostManager({ ...selectedHostManager, social_accounts: { ...selectedHostManager.social_accounts, twitter_x } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.manager.youtube} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedHostManager.social_accounts["youtube"]} fill onInputComplete={(youtube: string) => {
                                setSelectedHostManager({ ...selectedHostManager, social_accounts: { ...selectedHostManager.social_accounts, youtube } });
                            }} />
                        </FormControl>
                    </div>
                    <div>
                        <MediaInput style={{ marginBottom: 0 }} width={190} height={190}
                            noFillTemplate default={selectedHostManager.passport_picture_url} onSelectFiles={(files) => {
                                consusService.uploadFile("/omnehost/host/manager/", `passport_${selectedHostManager?.external_id}`, files[0]).then(({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                                    setSelectedHostManager({ ...selectedHostManager, passport_picture_url: sanitized.consus_download_url });
                                    updateHostManager({ ...selectedHostManager, passport_picture_url: sanitized.consus_download_url });
                                }).catch(BaseService.reportError);
                            }} onGenerateWithAi={async () => {
                                return new File(["We are here"], "we.txt", { type: 'text/plain' });
                            }} />
                        <FormControl isFieldset fill label={labels.manager.display_name} style={{ marginTop: 15 }}
                            rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                                console.log("Get Profile account")
                            }} />}>
                            <TextInput defaultValue={selectedHostManager.display_name} fill onInputComplete={(value: string) => {
                                setSelectedHostManager({ ...selectedHostManager, display_name: value });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.manager.profile_description} style={{ marginTop: 15 }}
                            rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                                console.log("Get Profile account")
                            }} />}>
                            <TextAreaInput style={{ height: 200 }} defaultValue={selectedHostManager.profile_details} fill onInputComplete={(value: string) => {
                                setSelectedHostManager({ ...selectedHostManager, profile_details: value });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.manager.country} style={{ marginTop: 15 }} >
                            <TextInput defaultValue={selectedHostManager.settings.country} fill onInputComplete={(country: string) => {
                                setSelectedHostManager({ ...selectedHostManager, settings: { ...selectedHostManager.settings, country } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.manager.state_region} style={{ marginTop: 15 }} >
                            <TextInput defaultValue={selectedHostManager.settings.state_region} fill onInputComplete={(state_region: string) => {
                                setSelectedHostManager({ ...selectedHostManager, settings: { ...selectedHostManager.settings, state_region } });
                            }} />
                        </FormControl>
                        <Checkbox scheme={Schemes.OMNEHOST} label={labels.manager.hide_on_manager_page} style={{ marginTop: 20 }} defaultChecked={selectedHostManager.settings.hide_from_managers_page} onChecked={(checked) => {
                            setSelectedHostManager({ ...selectedHostManager, settings: { ...selectedHostManager.settings, hide_from_managers_page: checked } });
                        }} />
                        <Checkbox scheme={Schemes.OMNEHOST} label={labels.manager.show_profile_link} style={{ marginTop: 20 }} defaultChecked={selectedHostManager.settings.show_link_to_profile} onChecked={(checked) => {
                            setSelectedHostManager({ ...selectedHostManager, settings: { ...selectedHostManager.settings, show_link_to_profile: checked } });
                        }} />
                        <FormControl isFieldset fill label={labels.manager.discord} style={{ marginTop: 20 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedHostManager.social_accounts["discord"]} fill onInputComplete={(discord: string) => {
                                setSelectedHostManager({ ...selectedHostManager, social_accounts: { ...selectedHostManager.social_accounts, discord } });
                            }} />
                        </FormControl>
                    </div>
                </div>
                <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
                    style={{ marginTop: 20, padding: "10px 25px", alignSelf: "flex-end" }} onClick={(e) => updateHostManager(selectedHostManager, e.manageRef)} />
            </div>
        </div>)}
    </div>);

    function renderListing() {
        return (<div className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none" }}>
            <div className="tmembers">
                {!hostManagers.content
                    ? (Elements.LOADING_STATE)
                    : (hostManagers.content?.map((hostManager) => {
                        const isYou = hostManager.external_id === props.profile.external_id && (i18nManager.Labels.host.analytics.earnings.you);

                        return (<div className="tmember" key={hostManager.external_id} onClick={() => {
                            Utils.updateSearchParams("shmid", hostManager.external_id, setSearchParams, () => setSelectedHostManager(hostManager));
                        }}>
                            <div>
                                <img alt={hostManager.member?.username} src={hostManager.passport_picture_url} />
                                <div>
                                    <span className="n">{hostManager.member?.username} {isYou ? `(${labels.you})` : ""}</span>
                                    <span className="ta"><span>{labels.role}</span> {hostManager.display_role}</span>
                                    <span className="ta"><span>{labels.joined}</span> {Utils.formatToFineDate(hostManager.join_date, true, true)}</span>
                                </div>
                            </div>
                        </div>);
                    }))}
            </div>
        </div>);
    }

    function fetchInformation() {
        setHostManagers({});
        hostService.queryHostManagers(props.host.external_id, {
            status: "ACTIVE",
            page: parseInt(searchParams.get("page") ?? "1"),
            size: parseInt(searchParams.get("size") ?? "100"),
        }).then(({ apiResponse }: SanitizedResponse<IHostManager>) => {
            setHostManagers(apiResponse.data!);
            for (const hm of apiResponse.data!.content ?? []) {
                if (hm.external_id === searchParams.get("shmid")) {
                    setSelectedHostManager(hm);
                    break;
                }
            }
        }).catch(BaseService.reportError);
    }

    function updateHostManager(hostManager: IHostManager, manageRef?: ButtonManageRef) {
        manageRef?.setLoadingState(true);
        hostService.updateHostManager(hostManager).then(({ sanitized }: SanitizedResponse<any>) => {
            Siren.alert(labels.update_success);
        }).catch(BaseService.reportError).finally(() => manageRef?.setLoadingState(false));
    }

}

export default People;
